export default function(x) {
  return x;
}



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-geo/src/identity.js
// module id = ../../../../d3-geo/src/identity.js
// module chunks = 4